import Country from '~/Api/Country/Country';
import RequiredLicenses from '~/Api/DataSource/RequiredLicenses';

export default class ProductDatasetSource {
	type: string;

	description: string;

	shortName: string;

	country: Country;

	singleUnitPackageSize: boolean;

	requiresLicence: RequiredLicenses;

	constructor(
		type: string,
		description: string,
		shortName: string,
		country: Country,
		singleUnitPackageSize: boolean,
		requiresLicence: RequiredLicenses
	) {
		this.type = type;
		this.description = description;
		this.shortName = shortName;
		this.country = country;
		this.singleUnitPackageSize = singleUnitPackageSize;
		this.requiresLicence = requiresLicence;
	}
}
